// extracted by mini-css-extract-plugin
export var actionButton = "_ez-t";
export var buttonContainer = "_ez-0";
export var buttonContainer2 = "_ez-1";
export var buttonSection = "_ez-2";
export var details = "_ez-3";
export var dropdownItem = "_ez-5";
export var dropdownItemsContainer = "_ez-4";
export var fileInput = "_ez-r";
export var headerButton = "_ez-6";
export var icon = "_ez-7";
export var input = "_ez-8";
export var macroListItem = "_ez-9";
export var mainContent = "_ez-a";
export var microText = "_ez-b";
export var modal = "_ez-w";
export var optionsButton = "_ez-c";
export var paperclip = "_ez-s";
export var pillContent = "_ez-d";
export var preview = "_ez-e";
export var preview2 = "_ez-f";
export var quillEditor = "_ez-q";
export var selectedMacro = "_ez-g";
export var sidebar = "_ez-h";
export var sidebarHeader = "_ez-j";
export var sidebarList = "_ez-i";
export var sidebarListItem = "_ez-k";
export var sidebarSearch = "_ez-l";
export var snoozeDurationWrapper = "_ez-v";
export var statusPillContainer = "_ez-m";
export var tagsContainer = "_ez-n";
export var unselectedMacro = "_ez-o";
export var variable = "_ez-u";
export var wrapper = "_ez-p";